import AsyncStorage from '@react-native-async-storage/async-storage';

// Redux Persist configuration
export const persistConfig = {
	key: 'root',
	storage: AsyncStorage,
	blacklist: [
		'modal',
		'actionMaker',
		'lastAction',
		'uploadPreview',
		'calendar',
		'notifications',
		'toolbar',
		'modals',
		'report',
	],
};
